<template>
<div class="chapter">
<div class="inner_page">
<p class="western3" id="calibre_pb_3"> <br class="calibre2"/></p>
<h2 class="western4">Also in The Journal series:</h2>
<p class="western5"> <br class="calibre2"/></p>
<p class="western6">Cracked Earth (Book One)</p>
<p class="western6">Ash Fall (Book Two)</p>
<p class="western6">Crimson Skies (Book Three)</p>
<p class="western6">Raging Tide (Book Four)</p>
<p class="western6"> <br class="calibre2"/></p>
<p class="western5"> <br class="calibre2"/></p>
<h2 class="western4">Also by Deborah D. Moore</h2>
<p class="western5"> <br class="calibre2"/></p>
<p class="western6">A Prepper’s Cookbook: Twenty Years of Cooking
in the woods,</p>
<p class="western6">Coming in Summer 2016!</p>
<p class="western7"> <br class="calibre2"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue?4ba1c032